(function () {
    let observer = null;

    function lazyLoadImages(wrapper = document.body, isSwiper = false) {
        const selector = isSwiper ? '.swiper-slide-visible img.lazyload' : 'img.lazyload';
        const images = wrapper.querySelectorAll(selector);

        if (!("IntersectionObserver" in window)) {
            images.forEach(img => preloadImage(img));
            return;
        }

        if (!observer) {
            observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        preloadImage(entry.target);
                        observer.unobserve(entry.target);
                    }
                });
            });
        }

        images.forEach(img => observer.observe(img));
    }

    function preloadImage(img) {
        if (img.classList.contains('loaded') || img.classList.contains('error')) return;

        const originalSrc = img.getAttribute('data-src');
        const originalSrcSet = img.getAttribute('data-srcset');

        if (!originalSrc) {
            console.warn('data-src не указан для изображения:', img);
            return;
        }

        activatePictureSources(img);
        applyLoadedImage(img, originalSrc, originalSrcSet);
    }

    function activatePictureSources(img) {
        const picture = img.closest('picture');
        if (!picture) return;
        picture.querySelectorAll('source[data-srcset]').forEach(source => {
            const sourceSet = source.getAttribute('data-srcset');
            if (sourceSet) {
                source.setAttribute('srcset', sourceSet);
            }
        });
    }

    function applyLoadedImage(img, src, srcset = null) {
        const picture = img.closest('picture');
        if (picture) {
            if (srcset) {
                img.srcset = srcset;
            }
            // Defer fallback <img src> so UA can apply <source srcset> first (AVIF/WebP).
            requestAnimationFrame(() => {
                img.src = src;
                img.classList.add('loaded');
            });
            return;
        }
        img.src = src;
        if (srcset) {
            img.srcset = srcset;
        }
        img.classList.add('loaded');
    }

    window.imagesLazyLoad = wrapper => lazyLoadImages(wrapper, false);
    window.imagesLazyLoadSwiper = wrapper => lazyLoadImages(wrapper, true);

    document.dispatchEvent(new Event("lazyloadReady"));
})();
